import { TypesLoading } from "@context/types/loading";
import { GlobalAction } from "@context/types";
export const loadingReducer = (state: boolean, action: GlobalAction) => {
  switch (action.type) {
    case TypesLoading.NotLoading:
      return false;
    case TypesLoading.Loading:
      return true;
    default:
      return state;
  }
};
